exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1HySP{margin-left:12px;white-space:nowrap}\n", ""]);

// Exports
exports.locals = {
	"text-button": "_1HySP",
	"textButton": "_1HySP"
};